module.exports = __webpack_public_path__ + "static/media/Component_2.c798d807.png";